
customElements.define(
  'sticky-atc',
  class StickyATC extends HTMLElement {
    constructor() {
      super();

      const parent = this;
      const header = document.querySelector('.header-wrapper');

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const isHidden =
              (entry.isIntersecting && entry.boundingClientRect.top <= 100) || entry.boundingClientRect.top > 100;
            parent.classList.toggle('hidden', isHidden);
            header.classList.toggle('medium-hide', !isHidden);
            header.classList.toggle('large-up-hide', !isHidden);
            this.updateHeadingWidth();
          });
        },
        {
          root: null,
          rootMargin: '-100px',
          threshold: 0,
        }
      );

      document.querySelectorAll(this.dataset.target).forEach((el) => {
        observer.observe(el);
      });

      const label = this.querySelector('label.button.button--primary');
      const addButtonId = this.dataset.target.substring(1);

      const styleObserver = new MutationObserver(
        (mutations) => {
          mutations.forEach((record) => {
            console.log('New display value =', record.target.style.getPropertyValue('display'))
            if (record.target.style.getPropertyValue('display') === 'none') {
              label.textContent = window.variantStrings.addToCart;
              label.setAttribute('for', addButtonId);
            } else {
              label.textContent = 'Me prévenir par mail';
              label.setAttribute('for', 'BIS_trigger');
            }
          });
        }
      )

      const domObserver = new MutationObserver(
        (mutations, obs) => {
          mutations.forEach((record) => {
            record.addedNodes.forEach(el => {
              if (el.id === 'BIS_trigger') {
                styleObserver.observe(el, {
                  attributes: true,
                  attributeFilter: ['style'],
                });

                if (el.style.getPropertyValue('display') === 'none') {
                  label.textContent = window.variantStrings.addToCart;
                  label.setAttribute('for', addButtonId);
                } else {
                  label.textContent = 'Me prévenir par mail';
                  label.setAttribute('for', 'BIS_trigger');
                }

                obs.disconnect();
              }
            });
          });
        }
      );

      document.querySelectorAll(`product-form[data-section-id="${this.dataset.sectionId}"]>form[data-type="add-to-cart-form"]`).forEach((el) => {
        domObserver.observe(el, { childList: true });
      });

      this.heading = this.querySelector('h2');
      this.headingText = this.querySelector('h2>span');

      this.updateHeadingWidth();
      window.addEventListener('resize', this.updateHeadingWidth.bind(this));

      this.listenEvents();
    }

    updateHeadingWidth() {
      this.heading.style.maxWidth = 'unset';
      setTimeout(() => {
        this.heading.style.maxWidth = this.headingText.offsetWidth + 1 + 'px';
      }, 0);
    }


    connectedCallback() {
      this.setStickyHeight();
    }

    listenEvents() {
      const productInfo = document.querySelector('product-info');

      this.querySelector('fieldset').addEventListener('click', (e) => {
        const productInput = productInfo.querySelector(`#${e.target.getAttribute('for')}`);
        if (e.target.getAttribute('for') && productInput.closest('variant-dropdowns')) {
          productInput.closest('variant-dropdowns').querySelector('.variant-dropdowns__btn-text').innerText =
            e.target.innerText;
        }
      });
    }

    setStickyHeight() {
      document.documentElement.style.setProperty('--sticky-atc-height', `${this.offsetHeight}px`);
    }
  }
);
